import $ from "jquery";
import Storage from "@bd-utils/storage";
import BD_Component from "@bd-core/bd-component";
import compile from "@bd-utils/handlerbars-helper";
import CONFIG from "@bd-core/config";
import { getState } from "@bd-stores/store";
import { getRoomAnswerById } from "@bd-stores/game-data";
import { getFinalTeamAnswers, getRoomStatus } from "@bd-stores/game-progress";
import CompletionPopup from "@bd-utils/completion-popup";
import {
    getRoomAnswers,
    maybeUpdateRoomStatus,
    saveFinalRoomAnswers,
    setMiddleState,
    updateRoomAnswer,
} from "@bd-core/firebase-actions";
import gsap from "gsap";
import Draggable from "gsap/Draggable";

export class RoomMultipleQuestion extends BD_Component {
    constructor() {
        super();

        this.id = "multiple_question";
        this.templateID = "multiple_question-template";

        this.elms = {
            closeQuestion: ".js-multipleQuestions-close",
            openQuestion: ".js-multipleQuestions-open",
            questionPopup: ".js-questions-popup",
            booleanAnswer: ".js-boolean-answer",
            booleanItem: ".js-question",
            answers: ".js-answers",
            checkBtn: ".js-check",
            check: ".js-action",
            count: ".count",
            correct: ".js-correct",
            middle: ".js-middle",
            wrong: ".js-wrong",
            roomStatus: ".js-room-status",
            background: ".js-screen-img",
            backgroundImage: ".screen__navigate",
            closeButtonPopup: ".multipleQuestions__close",
            backButton: ".app__back",
        };

        this._events = this.getEvents();

        this.completionPopup = new CompletionPopup();

        this.startX = 0;
        this.startY = 0;
        this.zoom = 100;
        this.hotspotSize = 25.5;
        this.isDown = false;
    }

    /**
     * @returns {Array<BD_ComponentEvent>}
     */
    getEvents() {
        const elms = this.elms;
        return [
            {
                event: "click",
                selector: elms.openQuestion,
                handler: this.onQuestionToggler,
            },
            {
                event: "click",
                selector: elms.closeQuestion,
                handler: this.onQuestionToggler,
            },
            {
                event: "change",
                selector: elms.booleanAnswer,
                handler: this.onAnswerBoolean,
            },
            {
                event: "click",
                selector: elms.checkBtn,
                handler: this.onCheck,
            },
            {
                event: "wheel",
                selector: elms.background,
                handler: this.onBackgroundScroll,
            },
        ];
    }

    beforeInit() {
        this.render();
        this.setGameState();
    }

    getModifiedData() {
        const modified = { ...this._data };

        let _challenge = this._data.challenges;
        const defaultNormalImage = `${CONFIG.themeURL}/assets/images/multiplequestion-item-new.png`;
        const defaultHoverImage = `${CONFIG.themeURL}/assets/images/multiplequestion-item-hover-new.png`;
        const defaultImageBg = `${CONFIG.themeURL}/assets/images/bg-multiple-questions-new.png`;

        const _image_bg = this._data.image_bg
            ? this._data.image_bg
            : defaultImageBg;

        _challenge = {
            normal_image: _challenge.normal_image
                ? _challenge.normal_image
                : defaultNormalImage,
            hover_image: _challenge.hover_image
                ? _challenge.hover_image
                : defaultHoverImage,
        };

        const hintHotspots = this._data.hotspots.filter(
            (h) => h["hotspot_type"] === "hint",
        );

        const hotspotCount = hintHotspots.length;
        const defaultValue = "50%";

        const _hints = this._data.hints.map((hint, i) => {
            const font_fam = hint.hint_font_family.split("|");
            const font_name = font_fam[0];
            const font_category = font_fam[1];

            return {
                ...hint,
                font_family: `"${font_name}", ${font_category}`,
                has_image: hint.image,
                position_top:
                    hotspotCount > 0 && hintHotspots[i]
                        ? hintHotspots[i].position_top
                        : defaultValue,
                position_left:
                    hotspotCount > 0 && hintHotspots[i]
                        ? hintHotspots[i].position_left
                        : defaultValue,
            };
        });

        const _hotspots = this._data.hotspots
            .filter((h) => h["hotspot_type"] === "puzzle")
            .shift();

        const modifiedData = {
            ...modified,
            hints: _hints,
            hotspots: _hotspots,
            challenges: _challenge,
            image_bg: _image_bg,
        };

        return modifiedData;
    }

    render() {
        const modifiedData = this.getModifiedData();
        const isForcedOpenChallenge = modifiedData["force_open_challenge"];

        const htmlTemplate = $("#" + this.templateID).html();
        const html = compile(htmlTemplate, modifiedData);
        $(".app").html(html);

        if (isForcedOpenChallenge) {
            this.onForceOppenChallenge();
        }
    }

    setGameState() {
        const elms = this.elms;
        const roomId = this.roomId;
        const roomAnswers = getFinalTeamAnswers(roomId);
        const thisRoomStatus = getRoomStatus(roomId);
        let isMiddleState = false;

        const possibleStatuses = [
            "is-status-open",
            "is-status-started",
            "is-status-completed",
        ];

        if (thisRoomStatus) {
            const $status = $(".js-room-status");
            $status.removeClass(possibleStatuses);
            $status.addClass(thisRoomStatus);
        }

        //reset answer state
        $(elms.booleanAnswer).removeClass("is-active");
        this.toggleCheckButton();

        const setSelectedAnswers = function (answers) {
            $.each(answers, function (questionID, objAnswer) {
                const answerValue = objAnswer?.answer || objAnswer;

                isMiddleState =
                    objAnswer?.isMiddleState && !isMiddleState
                        ? true
                        : isMiddleState;

                const $question = $(
                    elms.booleanItem + `[data-id="${String(questionID)}"]`,
                );

                $question
                    .find(elms.booleanAnswer + `[data-id="${answerValue}"]`)
                    .prop("checked", true)
                    .addClass("is-active");
            });
        };

        if (roomAnswers && Object.keys(roomAnswers).length) {
            setSelectedAnswers(roomAnswers);
        } else {
            //get individual answers from local storage
            const individualAnswers = this.getSavedAnswers();
            if (Object.keys(individualAnswers).length) {
                setSelectedAnswers(individualAnswers);
                this.toggleCheckButton();
            }
        }

        if (thisRoomStatus == "is-status-completed") {
            if (!this.meSubmittingAnswer)
                $(elms.check).removeClass("is-checked");

            $(elms.questionPopup).addClass("is-completed");
            $(".app__page").addClass("is-room-completed");

            /* Show completion popup */
            this.completionPopup.show(roomId, isMiddleState, roomAnswers);
        }

        getRoomAnswers(roomId).then((data) => {
            this.updateUserChoicesList(data);
        });

        if ($(window).width() / $(window).height() === 1.6) {
            this.hotspotSize += 2.5;
            $(".js-challenge-coordinate")[0].style["top"] = "52.4%";
            $(".js-challenge-coordinate")[0].style["left"] = "35.8%";
        }

        gsap.registerPlugin(Draggable);
        let companions;

        Draggable.create(".js-draggable", {
            bounds: $(".screen__container"),
            dragResistance: 0.5,
            edgeResistance: 1,
            type: "x,y",
            zIndexBoost: false,
            onPress: function () {
                const screens = document.querySelectorAll(".js-draggable");
                let i = screens.length;
                companions = [];
                RoomMultipleQuestion.prototype.startX = this.x;
                RoomMultipleQuestion.prototype.startY = this.y;
                while (--i > -1) {
                    if (companions[i] !== this.target) {
                        companions.push({
                            element: screens[i],
                            x: gsap.getProperty(screens[i], "x"),
                            y: gsap.getProperty(screens[i], "y"),
                        });
                    }
                }
                gsap.killTweensOf(".js-draggable");
            },
            onDrag: function () {
                let i = companions.length,
                    deltaX = this.x - RoomMultipleQuestion.prototype.startX,
                    deltaY = this.y - RoomMultipleQuestion.prototype.startY,
                    companion;
                while (--i > -1) {
                    companion = companions[i];
                    gsap.set(companion.element, {
                        x: companion.x + deltaX,
                        y: companion.y + deltaY,
                    });
                }
            },
        });
    }

    // ============================== CUSTOM FUNCTION

    onBackgroundScroll(e) {
        let delta = e.originalEvent.deltaY < 0 ? "up" : "down";
        let baseSize = $(this.elms.background)
            .css("font-size")
            .replace("px", "");
        let intBaseSize = parseFloat(baseSize);
        const hasHint = $(".hint__popup").length;

        if (hasHint) {
            const isHintHovered = $(".hint__popup").is(":hover");

            if (isHintHovered) return;
        }

        if (delta === "up" && this.zoom < 120) {
            this.zoom += 2;
            this.hotspotSize += 0.55;
        } else if (delta === "down" && this.zoom > 100) {
            this.zoom -= 2;
            this.hotspotSize -= 0.55;
        }
        $(this.elms.background).css({
            width: `${this.zoom}%`,
            height: `${this.zoom}%`,
            transform: `translate(-50%, -50%)`,
        });
        $(".screen__navigate").css({
            width: `${this.zoom}%`,
            height: `${this.zoom}%`,
            transform: `translate(-50%, -50%)`,
        });
        $(".js-screen-hotspot").css({
            fontSize: intBaseSize * (this.zoom / 100),
        });
        this.startX = 0;
        this.startY = 0;
        gsap.set(".js-draggable", { clearProps: "transform" });
    }

    /**
     * Decide whether to disabled or enabled boolean action (Check btn)
     * @returns {Boolean}
     */
    toggleCheckButton() {
        const elms = this.elms;
        let isAnsweredAll = true;

        $(elms.booleanItem).each(function () {
            const selected = `${elms.booleanAnswer}.is-active`;
            const isThisAnswered = $(this).find(selected).length > 0;
            if (!isThisAnswered) return (isAnsweredAll = false);
        });

        $(elms.checkBtn).prop("disabled", !isAnsweredAll);
        return isAnsweredAll;
    }

    getSavedAnswers() {
        const roomID = this.roomId;
        const states = Storage.get("states", {});
        const savedAnswers = states?.answers?.[roomID] || {};

        return savedAnswers;
    }

    setSavedAnswers(answers) {
        const roomID = this.roomId;
        let states = Storage.get("states", {});
        if (!states?.answers) states.answers = {};
        if (!states?.answers?.[roomID]) states.answers[roomID] = {};
        states.answers[roomID] = answers;

        return Storage.set("states", states);
    }

    /**
     * Save answer for particular questionId into local storage
     * @param {string} questionId
     * @param {string} value
     */
    saveAnswer(questionId, value) {
        let savedAnswers = this.getSavedAnswers();
        savedAnswers[questionId] = value;
        this.setSavedAnswers(savedAnswers);
        this.updateUserAnswer(savedAnswers);
    }

    onAnswerBoolean(e, el) {
        const $this = $(el);
        const elms = this.elms;
        const $boolean = $this.parents(elms.questionPopup);

        if ($boolean.hasClass("is-completed")) {
            return false;
        }

        //save the answer into local storage
        const questionID = $this.parents(elms.booleanItem).attr("data-id");
        const theAnswer = $this.attr("data-id");
        this.saveAnswer(questionID, theAnswer);

        const inputParent = $this.parents(elms.answers);
        inputParent.find(elms.booleanAnswer).removeClass("is-active");
        $this.addClass("is-active");
        this.toggleCheckButton();
    }

    onCheck(e, el) {
        const elms = this.elms;
        const $el = $(el);

        if ($el.hasClass("is-loading") || $el.hasClass("is-completed")) return;

        $el.parent().removeClass("is-checked");
        $el.addClass("is-loading").prop("disabled", true);

        const roomID = this.roomId;
        let roomStatus = "is-status-started";
        let roomAnswers = getRoomAnswerById(roomID);
        let playerAnswers = {};
        let correct_count = 0;
        let middle_count = 0;
        let wrong_count = 0;
        let isMiddleState = false;

        $(elms.booleanItem).each(function () {
            const $item = $(this);
            const $answer = $item.find(elms.booleanAnswer + ".is-active");
            const qId = $item.attr("data-id");
            const answer = $answer.attr("data-id");

            playerAnswers[qId] = {
                answer: answer,
                isMiddleState: false,
            };
        });

        for (let key in playerAnswers) {
            const playerAnswer = playerAnswers[key].answer;
            const correctAnswers = roomAnswers?.[key]?.correct || [];
            const middleAnswers = roomAnswers?.[key]?.middle || [];
            const isUsingMiddleState = this._data.isUseMiddleState;

            if (correctAnswers.includes(playerAnswer)) {
                correct_count++;
            } else if (
                isUsingMiddleState &&
                middleAnswers.includes(playerAnswer)
            ) {
                middle_count++;
                isMiddleState = true;
                playerAnswers[key].isMiddleState = true;
            } else {
                wrong_count++;
            }
        }

        const isAllCorrect =
            wrong_count === 0 && (correct_count > 0 || middle_count > 0);

        if (isAllCorrect) {
            roomStatus = "is-status-completed";
            this.meSubmittingAnswer = true; // a flag to set the UI state

            if (isMiddleState) setMiddleState(roomID);

            const onSuccess = () => {
                $el.parent().addClass("is-completed");
                $el.parents(elms.questionPopup).addClass("is-completed");
            };

            saveFinalRoomAnswers(roomID, playerAnswers)
                .then(onSuccess)
                .catch(() => (this.meSubmittingAnswer = false));
        }

        $el.parent().addClass("is-checked");

        $(elms.correct).find(".count").text(correct_count);
        $(elms.middle).find(".count").text(middle_count);
        $(elms.wrong).find(".count").text(wrong_count);

        $el.removeClass("is-loading").removeAttr("disabled");

        maybeUpdateRoomStatus(roomID, roomStatus);
    }

    onQuestionToggler() {
        const elms = this.elms;
        const hasOpen = $(elms.questionPopup).hasClass("is-open");
        const isOpened = !hasOpen;
        const blur = $(".app-blur");

        blur.toggleClass("is-blurred", isOpened);

        $(elms.questionPopup).toggleClass("is-open", isOpened);
    }

    onForceOppenChallenge() {
        const elms = this.elms.questionPopup;
        const closeButton = this.elms.closeButtonPopup;
        const backButton = this.elms.backButton;

        const blur = $(".app-blur");

        blur.addClass("is-blurred");

        $(elms).addClass("is-open");
        $(closeButton).addClass("hidden");
        $(backButton).addClass("up-front");
    }

    updateUserAnswer(answers) {
        const roomId = this.roomId;
        const currentPlayerId = CONFIG.user.id;

        updateRoomAnswer(roomId, {
            [currentPlayerId]: {
                user_id: currentPlayerId,
                choice: answers,
            },
        });
    }

    updateUserChoicesList(answer) {
        if ($("#locationInfo-item").length < 1) return;

        const fbRoomAnswers = answer.val() ?? {};
        const players = getState().gameProgress.players;
        const template = $("#locationInfo-item").html();

        // Filter the player to not include the current user
        const onlinePlayers = players.filter(
            (player) => player.isOnline && player.userId !== CONFIG.user.id,
        );

        $(".userChoice_list").each(function () {
            const $context = $(this).parents(".js-userChoices-context");
            const hasContext = $context.length > 0;

            const questionID = hasContext
                ? $context.attr("data-question-id")
                : undefined;
            const questionAnswerID = hasContext
                ? $context.attr("data-answer-id")
                : undefined;

            const users = onlinePlayers.filter((player) => {
                const usrID = player.userId;
                const thisPlayerAnswer = fbRoomAnswers[usrID]?.choice;

                if (typeof thisPlayerAnswer !== "object") {
                    return;
                }

                if (thisPlayerAnswer[questionID] == questionAnswerID) {
                    return player;
                }
            });

            const html = compile(template, { players: users });
            $(this).html(html);
        });
    }
}
